import { Category } from '../../models/category';

export type CategoryId = string;

export type CategoryArray = CategoryId[];

export const Eyewear: CategoryArray = ['84', '85', '86', '180', '181', '182', '239', '240', '241'];
export const shouldDisplayEyewearWarning = (categoryId, countryCode) => {
  return Eyewear.includes(categoryId) && countryCode.toUpperCase() === 'US';
};

export interface CategoryData {
  category?: Category;
  subCategories?: Category[];
}

export const getCategoryData = (selectedCatIds: string[], categories: Category[]): CategoryData => {
  if (!selectedCatIds || !selectedCatIds.length) {
    return {};
  }

  // if there are multiple selected categories they have to be siblings
  const catId = selectedCatIds[0];
  const cat = categories.find(c => c.id === catId);
  const isSubCategoriesRoot = cat.presentationWeight === '3';
  if (isSubCategoriesRoot) {
    const subCategories = categories.filter(c => c.parentId === catId);
    return {
      category: cat,
      subCategories,
    };
  }
  const isSubCategoriesLeaf = cat.presentationWeight === '4';
  if (isSubCategoriesLeaf) {
    const rootCategory = categories.find(c => c.id === cat.parentId);
    const subCategories = categories.filter(c => c.parentId === rootCategory.id);
    return {
      category: rootCategory,
      subCategories,
    };
  }
  return {
    category: cat,
  };
};
